export default __webpack_public_path__ + "static/media/3.dd318ca1.png";